import React, { useEffect, useState } from "react";
import { CommonUtilities } from "../../commonUtils";
import Pagination from "components/Common/newPagination";
import Header from "../Header/header";
import MainWizard from "../wizard/MainWizard";
import DealsManager from "../Contacts/dealsManager";
import gridTemplateService from "./gridTemplateService";
import CommonSearch from "../commonSearch/CommonSearch";
import ContactAssetListingBox from "./ContactAssetListing";
import ContactSplitsListingBox from "./ContactSplitsListing";

export default function ContactGrid() {
    let [contactList, initContactList] = useState<any>([]);
    let [totalRows, setTotalRows] = useState(0);
    let [gridHeader, initGridHeader] = useState<any>([]);
    let [gridVisibility, initGridVisibility] = useState<any>([]);
    let [GridOriginal, initGridOriginal] = useState<any>([]);
    let [GridOrdering, initGridOrdering] = useState<any>([]);
    let [openMainWizard, setopenMainWizard] = useState(false)
    let [openDealsManager, setopenDealsManager] = useState(false)
    let [selectedMainWizard, setselectedWizard] = useState<any>([]);
    let [contactAssetListingStatus, setcontactAssetListingStatus] = useState(false);
    let [contactSplitsListingStatus, setcontactSplitsListingStatus] = useState(false);

    useEffect(() => {
        getContacts();
        //search();
    }, []);

    const Data: any = { pageSize: 10, pageNumber: 1, export: 0, searchFor: '', sortBy: '', sortOrder: '' }
    var dataLink = "pageSize=10&pageNumber=1";
    var search_For = "";
    const handleNameOnChange = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;
        dataLink = 'pageSize=' + Data.pageSize + '&pageNumber=' + Data.pageNumber;
        getContacts()
    }

    const getContacts = () => {

        for (var i = 0; i < GridOrdering.length; i++) {
            if (GridOrdering[i] === 1) {
                console.log(GridOrdering[i])
                console.log(GridOriginal[i])
                Data.sortBy = GridOriginal[i];
                Data.sortOrder = "ASC";
            }
        }

        gridTemplateService.ContactListing(Data).then((res) => {
            CommonUtilities.relativeDataRemapping(res.data, res.headers.original);
            initContactList(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));
            setTotalRows(res.totalRows)

            console.log(CommonUtilities.relativeDataRemapping(res.data, res.headers.original))
            initGridHeader(reMap(res.headers.display));
            initGridVisibility(reMap(res.headers.visible));
            initGridOriginal(reMap(res.headers.original));
            initGridOrdering(reMapOrdering(res.headers.original))

            console.log(reMap(res.headers.display))
        })
    }

    const SearchForHandle = (e: any, sts: any) => {
        console.log(e)
        console.log(sts)

        if ((sts === true)) {
        }
        var ARRAY_NEW: any = [];
        var payload = { ...e, ...Data };

        if (e.searchFor) {
            Object.values(e.searchFor).forEach(function (key) {
                ARRAY_NEW.push(key)
            })
        }

        payload.searchFor = ARRAY_NEW;
        Data.searchFor = ARRAY_NEW;

        console.log(payload)
        console.log(Data)

        getContacts();

    }

    const reMap = (mapReturn: any) => {
        var tempmapReturn: any[] = [];
        Object.entries(mapReturn).forEach(([key, value]) => { tempmapReturn.push(value) });
        return tempmapReturn;
    }

    const reMapOrdering = (mapReturn: any) => {
        //0 order by not selected
        // 1 order by 

        var tempmapReturn: any[] = [];
        Object.entries(mapReturn).forEach(([key, value]) => { tempmapReturn.push(0) });

        console.log(tempmapReturn)
        return tempmapReturn;
    }

    const reMapOrderingSet = (index: any) => {
        //0 order by not selected
        // 1 order by 
        for (var i = 0; i < GridOrdering.length; i++) {
            GridOrdering[i] = 0;
        }

        GridOrdering[index] = 1;
        initGridOrdering((existingValues: any) => ([...GridOrdering]));

        getContacts();
    }

    const search = (e: any) => {
        Data.searchFor = e;
        getContacts()
    }

    const MainWizardClose = () => {
        setopenMainWizard(false)
    }

    const exportContact = (type: any) => {
        gridTemplateService.exportContact({ export: true, exportType: type });
    }

    const savecontactsGridResult = (filterName: any, status: any) => {
        console.log(filterName)
        console.log(status)
        gridTemplateService.savecontactsGridResult({ filterName: filterName, status: status === 0 ? 1 : 0, type: "contactsGridResult" }).then((res) => { getContacts(); })
    }

    const onSaveUpdate = (e: any) => {
        console.log(e);
        setselectedWizard(e)
    }

    const closeDealsManager = () => {
        setopenDealsManager(false)
    }


    const contactAssetListing = () => {
        contactAssetListingStatus = true;
        setcontactAssetListingStatus(contactAssetListingStatus)
    }

    const contactSplitsListing = () => {
        contactSplitsListingStatus = true;
        setcontactSplitsListingStatus(contactSplitsListingStatus)
    }

    const closContactSplit = () => {
        contactSplitsListingStatus = false;
        setcontactSplitsListingStatus(contactSplitsListingStatus)
    }

    const closContactAsset = () => {
        contactAssetListingStatus = false;
        setcontactAssetListingStatus(contactAssetListingStatus)
    }

    return (
        <div className="ws-12 landingContainer">

            <div className='ws-12 bgWhite'>
                <Header Title={"Contacts"} />
            </div>

            <div className='ws-12 mtl pLarge '>
                <CommonSearch SearchForHandle={SearchForHandle} type="contactGrid" title="Contact" width="ws-12 pull-left" />
            </div>

            <div className="ws-12 landingPage pm">

                <div className="ws-12">
                    <div className="box-header">
                        <h2 className="pull-left capitalize">Search Results: {totalRows}</h2>

                        <div className="pull-right">
                            <div className="verticalMediumWide hover-box pull-right">
                                <ul className="hover-block textboxDropdownList box pLarge rightReset">

                                    {gridHeader?.map((values: any, index: any) => {

                                        if (values !== 'totalRow' && gridVisibility[index] !== 2) {
                                            return (
                                                <li className="hover-box text-left ws-6 pb">
                                                    <input type="checkbox" checked={gridVisibility[index]} onClick={() => savecontactsGridResult(GridOriginal[index], gridVisibility[index])} /> {values}
                                                </li>
                                            )
                                        }
                                    })}

                                </ul>
                                <button className="btn icon-btn info">
                                    <i className="icon-LPurple-Setting m0 p0"></i>
                                </button>
                            </div>

                            <button className="icon-btn edit pull-right mr" onClick={() => { setopenMainWizard(true); setselectedWizard({}); }}>
                                <i className="icon-user-add"></i>Add new Contact
                            </button>

                            <div className="vertical hover-box text-center pull-right">
                                <ul className="hover-block textboxDropdownList blockWidth">
                                    <li className="hover-box cursorText">
                                        <label className="btn full-width btn-xs cursorText text-bold" onClick={() => exportContact('BasicContactDetails')}> Basic Contact Details</label>
                                    </li>

                                    <li className="hover-box cursorText">
                                        <label className="btn full-width btn-xs cursorText text-bold" onClick={() => exportContact('AdditionalContactRecipients')}>Additional Contact Recipients</label>
                                    </li>

                                    <li className="hover-box cursorText">
                                        <label className="btn full-width btn-xs cursorText text-bold" onClick={() => exportContact('ContactStatuses')}>Contact Statuses</label>
                                    </li>

                                    <li className="hover-box cursorText">
                                        <label className="btn full-width btn-xs cursorText text-bold" onClick={() => exportContact('MergedContactRecipients')}>Merged Contact Recipients</label>
                                    </li>

                                </ul>
                                <button type="button" className="icon-btn primary"> <i className="icon-download1"></i> Export</button>
                            </div>
                        </div>
                    </div>

                    <div className="box-content allowHscroll">

                        {totalRows > 0 && gridHeader && <table className="table-responsive_big">
                            <thead>
                                <tr>
                                    {
                                        gridHeader?.map((values: any, index: any) => {
                                            if (values !== 'totalRow' && gridVisibility[index] === 1) {
                                                return (<>
                                                    <th className="forceSingleLine">
                                                        <span >{values} </span>

                                                        <a className="pl" onClick={() => reMapOrderingSet(index)}>
                                                            {GridOrdering[index] === 0 && <span style={{ fontSize: "10px" }}>↕</span>}
                                                            {GridOrdering[index] === 1 && <span>↑</span>}
                                                            {GridOrdering[index] === 2 && <span>↓</span>}
                                                            <span className="hide"> {GridOrdering[index]} </span>
                                                        </a>
                                                    </th>
                                                </>)
                                            }
                                        })
                                    }

                                    <th className="forceSingleLine">Operation</th>
                                </tr>
                            </thead>

                            <tbody>

                                {
                                    contactList?.map((Datavalues: any, index: any) => {
                                        return (
                                            <tr>
                                                {GridOriginal?.map((values: any, index: any) => {
                                                    if (values !== 'totalRow' && gridVisibility[index] === 1) {
                                                        return (<>
                                                            <td>

                                                                <a className={Datavalues[values] && values === "statementStatusName" ? "btn ws-12 text-center full-width inline pull-none" : "hide"}
                                                                    style={{
                                                                        background: CommonUtilities.lookUpTypeList('statementStatusName', Datavalues[values], 'bgColor'),
                                                                        color: CommonUtilities.lookUpTypeList('statementStatusName', Datavalues[values], 'fontColor')
                                                                    }} >
                                                                    {Datavalues[values]}
                                                                </a>


                                                                <a className={Datavalues[values] && values === "payeeStatusName" ? "btn ws-12 text-center full-width inline pull-none" : "hide"}
                                                                    style={{
                                                                        background: CommonUtilities.lookUpTypeList('payeeStatusName', Datavalues[values], 'bgColor'),
                                                                        color: CommonUtilities.lookUpTypeList('payeeStatusName', Datavalues[values], 'fontColor')
                                                                    }} >
                                                                    {Datavalues[values]}
                                                                </a>

                                                                <span className={values != "payeeStatusName" && values != "statementStatusName" ? "" : "hide"}>
                                                                    {Datavalues[values]}
                                                                </span>

                                                            </td>
                                                        </>)
                                                    }
                                                })}
                                                <td width={310} >
                                                    <button className="icon-btn primary" onClick={() => { setopenDealsManager(true); setselectedWizard(Datavalues); }}><i className="icon-track"></i></button>
                                                    <button className="icon-btn edit" onClick={() => { setopenMainWizard(true); setselectedWizard(Datavalues); }}><i className="icon-edit"></i></button>
                                                    <button className="icon-btn edit" onClick={() => { contactAssetListing(); setselectedWizard(Datavalues); }} title="Contact Assets">Assets</button>
                                                    <button className="icon-btn edit" onClick={() => { contactSplitsListing(); setselectedWizard(Datavalues); }} title="Contact Split">Split</button>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>}
                    </div>
                    {
                        (() => {
                            if (totalRows && totalRows > 10) {
                                return  <Pagination onPageChange={handleNameOnChange} totalRow={totalRows} />;
                            }
                        })()
                    }

                </div>
            </div>

            {(() => {
                if (openMainWizard) {
                    return <MainWizard openMainWizard={openMainWizard} MainWizardClose={MainWizardClose} type="Contact" code={selectedMainWizard.kontactCode} onSaveUpdate={onSaveUpdate} />
                }

                if (openDealsManager) {
                    return <DealsManager openDealsManager={openDealsManager} closeDealsManager={closeDealsManager} code={selectedMainWizard} />
                }

                if (contactSplitsListingStatus) {
                    return <ContactSplitsListingBox contactSplitOpen={contactSplitsListingStatus} closContactSplit={closContactSplit} code={selectedMainWizard} />
                }

                if (contactAssetListingStatus) {
                    return <ContactAssetListingBox contactAssetOpen={contactAssetListingStatus} closContactAsset={closContactAsset} code={selectedMainWizard} />
                }

            })()}
        </div>
    );
}